var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"operation-report-show-body-header-action-buttons flex"},[(_vm.canEdit)?_c('edit-button',{on:{"click":_vm.onClickEdit}}):_vm._e(),(_vm.canDelete)?_c('delete-button',{on:{"click":_vm.onClickDelete}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }